<template>
	<div class="row justify-content-center">
		<div class="col-12 mb-4" :style="'padding-bottom: '+pb+'px'">
			<div ref="fixedContent" class="row justify-content-center fixed-wrapper">
				<div class="col-11">
					<button class="btn text-left px-0" @click="$router.back()">
						<i class="fa fa-chevron-left"></i>&nbsp;{{ $t('Zurück') }}
					</button>
					<barcode-scanner @change="fetchBottleIfNeeded"/>
					<hr style="margin-bottom: 0;">
				</div>
			</div>

		</div>
		<div class="col-11" v-if="bottle">

			<h3>{{ $t('Nr.') }} {{ bottle.serial }}</h3>

			<hr>

			<span class="text-danger">{{ $t('Fällig am:') }}<br>
			{{ new Date(bottle.due).toLocaleDateString() }}</span>

			<bottle-action-log :actions="reverseBottleActions" class="mt-3"/>


		</div>
	</div>
</template>

<script>
import BarcodeScanner from "../components/BarcodeScanner";
import {mapActions, mapMutations, mapState} from "vuex";
import BottleActionLog from "../components/admin/BottleActionLog";

export default {
	name: "BottleDetail",
	components: {BottleActionLog, BarcodeScanner},
	data() {
		return {
			// bottle_id: String,
			lock: false,
			// bottle: null,
			detailCols: ['customer', 'action', 'date'],
			pb: 0,
		}
	},
	computed: {
		...mapState({
			bottle: state => state.Api.Bottles.current
		}),
		fixedStyle() {
			return {
				position: 'fixed',
				width: '100vw',
				background: 'white',
				'z-index': 999
			}
		},
		reverseBottleActions() {
			return this.bottle.bottle_actions.slice().reverse();
		}
	},
	mounted() {
		window.setTimeout(this.updateStyle, 500);
	},
	methods: {
		...mapActions({
			fetchBottleDetails: "Api/Bottles/get"
		}),
		...mapMutations({
			setBottle: "Api/Bottles/setCurrent"
		}),
		fetchBottleIfNeeded(serial) {
			if (!serial) {
				return;
			}

			if (this.lock) {
				return;
			}

			if (!this.bottle || serial !== this.bottle.serial) {
				this.lock = true;
				this.cdvBeep(1);
				this.fetchBottleDetails({id: serial})
					// .then((result) => {
					// 	console.log('successfully fetched Bottle Details', result);
					// 	// this.bottle = result;
					// })
					.catch((error) => {
						this.setBottle({item: null})
						this.apiErrorHandler(error);
					})
					.finally(() => {
						window.setTimeout(() => {
							this.lock = false
						}, 2000)
					})
			}
		},
		updateStyle() {
			this.pb = this.$refs.fixedContent.clientHeight
		},
	}
}
</script>

<style scoped>

</style>
